import type { IconData } from '@stacksjs/iconify-core'

export const yinYangSymbolSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5c12.426 0 22.5 10.074 22.5 22.5S36.426 46.5 24 46.5S1.5 36.426 1.5 24q0-1.21.125-2.386C2.817 10.31 12.38 1.5 24 1.5m10.393 5.998A11.95 11.95 0 0 1 36 13.5c0 6.627-5.373 12-12 12a9 9 0 1 0 0 18c10.77 0 19.5-8.73 19.5-19.5c0-6.949-3.635-13.049-9.107-16.502M24 17.5a4 4 0 1 1 0-8a4 4 0 0 1 0 8m-4 17a4 4 0 1 1 8 0a4 4 0 0 1-8 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default yinYangSymbolSolid
